<div style="position:relative;width:100%;height:100%;overflow: hidden;" #scrollContainer >
    <img class="chart-image" #img [src]="getImage()" (click)="onClick($event)" [ngStyle]="getImageStyle()">

    <img *ngIf="mChart.chartData" (window:resize)="onResize($event)" [src]="getArrowImage()" [ngStyle]="getPointerPositionStyle()">
</div>
